import React from 'react';

// Images
import GoogleLogo from 'Shared/images/google-logo.svg';

// Components
import { WpButton, Variant } from 'Wpds/components/button';

import './GoogleButton.scss';

type Props = {
  variant?: Variant;
  googleSignUpUrl: string;
  children: React.ReactNode;
  handleClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

const GoogleButton = ({ variant = 'primary', googleSignUpUrl, children, handleClick }: Props) => {
  const handleOnClick = event => {
    window.location.href = googleSignUpUrl;
    handleClick(event);
  };

  const baseClassName = 'GoogleButton';

  return (
    <WpButton variant={variant} onClick={handleOnClick} block size="lg">
      <img src={GoogleLogo} className={`${baseClassName}__logo-img`} />
      {children}
    </WpButton>
  );
};

export default GoogleButton;
